import { FormControlLabel, IconButton, Modal, Switch, Typography } from '@mui/material';
import propTypes from 'prop-types';
import { useState } from 'react';
import { useFirestore } from 'react-redux-firebase';
import collections from '../../../constants/FirestoreCollections';
import { useDispatch } from 'react-redux';
import { actions } from '../../../actions';
import { Box } from '@mui/system';
import WarningIcon from '@mui/icons-material/Warning';
import CloseIcon from '@mui/icons-material/Close';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  maxWidth: 600,
  background: 'rgba(255, 255, 255, 1)',
  border: '2px solid #ccc',
  borderRadius: 8,
  boxShadow: 24,
  p: 4,
  m: 0,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
};
export const ModalForceUpdateKpi = ({ modalOpen, setModalOpen, prestobotsConfig }) => {
  const firestore = useFirestore();
  const [isSwitchOn, setIsSwitchOn] = useState(prestobotsConfig.enableKpiForceUpdate || false);
  const appDispatch = useDispatch();
  const setSnackBarAlert = (message, severity) => {
    return appDispatch({
      type: actions.alert,
      alert: {
        snackbarOpen: true,
        snackbarMessage: message,
        snackbarSeverity: severity,
      },
    });
  };
  const handleEnableKpiForceUpdate = async (event) => {
    try {
      setIsSwitchOn(event.target.checked);
      const docId = prestobotsConfig.id;
      await firestore
        .collection(collections.configurations)
        .doc(docId)
        .update({ enableKpiForceUpdate: event.target.checked });
      setSnackBarAlert(
        `Actualizacion forzosa ${event.target.checked ? 'activada' : 'desactivada'}`,
        'success',
      );
    } catch (error) {
      console.log('handleUpdateenableKpiForceUpdate', error);
      setSnackBarAlert('Ocurrio un error, intente mas tarde', 'error');
      setIsSwitchOn(prestobotsConfig.enableKpiForceUpdate);
    }
  };
  return (
    <Modal
      open={modalOpen}
      onClose={() => setModalOpen(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box sx={style}>
        <IconButton
          onClick={() => setModalOpen(false)}
          sx={{
            position: 'absolute',
            top: 8,
            right: 8,
            color: 'white',
            '&:hover': {},
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          variant="body2"
          style={{ marginTop: 8, textAlign: 'justify', fontSize: '1.5rem' }}
        >
          <Box display="flex" alignItems="center" justifyContent="center" mb={1}>
            <WarningIcon style={{ marginRight: 4 }} />
            <strong>Advertencia:</strong>
          </Box>
        </Typography>
        <Typography
          variant="body2"
          style={{ marginTop: 8, marginBottom: 8, textAlign: 'justify', fontSize: '1rem' }}
        >
          La actualización forzosa significa que estos gráficos se actualizaran
          <strong> cada vez que se cargue la página actual</strong>, lo cual puede resultar en un{' '}
          <strong style={{ color: 'red' }}>
            aumento considerado en el consumo de servicios de Google{' '}
          </strong>
          y por lo tanto puede incrementar significativamente los costos si se usa de manera
          excesiva. <br /> Esta configuración afecta a <strong>TODOS los clientes.</strong>
        </Typography>
        <FormControlLabel
          value="Actualizacion sin limites"
          control={
            <Switch
              color="error"
              checked={isSwitchOn}
              onChange={handleEnableKpiForceUpdate}
              sx={{
                transform: 'scale(1.5)',
              }}
            />
          }
          label={isSwitchOn ? 'Desactivar' : 'Activar'}
          labelPlacement="start"
          sx={{
            mt: 0,
            '& .MuiTypography-root': {
              fontSize: '1.3rem',
              marginRight: '1rem',
            },
          }}
          style={{ height: '50%' }}
        />
      </Box>
    </Modal>
  );
};

const Props = {
  modalOpen: propTypes.bool,
  setModalOpen: propTypes.bool,
  prestobotsConfig: propTypes.object,
};

ModalForceUpdateKpi.propTypes = Props;
